import { toast } from "sonner";

export const toastInfo = (msg, duration = 10) => {
  toast.info(msg, {
    duration: duration * 1000,
    style: {
      whiteSpace: 'pre-line',
    },
  });
};

export const toastError = (msg, duration = 10) => {
  toast.error(msg, {
    duration: duration * 1000,
  });
};

export const toastAlert = (msg) => {
  const id = toast.info(msg, {
    duration: Infinity,
    action: {
      label: '확인',
      onClick: () => toast.dismiss(id),
    }
  });
};